import { composeGetHasSharingIssues } from '../actions/publicActions';
import isCheckPermPending from '../utils/isCheckPermPending';
import { logUsage } from 'owa-analytics';
import { orchestrator } from 'satcheljs';

orchestrator(composeGetHasSharingIssues, async actionMessage => {
    const result: boolean = isCheckPermPending(actionMessage.composeId);
    if (result) {
        logUsage('checkPermPendingWhenSend');
    }
});
